<template>
    <el-dialog
        :model-value="props.visible"
        title="外呼设备检测"
        width="600"
        top="6vh"
        destroy-on-close
        :close-on-click-modal="false"
        @open="onOpen"
        @closed="closedModal"
    >
        <div v-loading="pageLoading"
             element-loading-text="检测中..."
             style="min-height: 100px;"
        >
            <div>
                <el-result
                    v-if="uiInfo.errorMsg"
                    icon="error"
                    title="麦克风检测失败"
                    :sub-title="uiInfo.errorMsg"
                />

                <el-image
                    v-if="uiInfo.errorMsg && uiInfo.errorMsg.indexOf('同时') > -1"
                    preview-teleported
                    style="width: 450px;margin-top: -30px;margin-left: 50%;transform: translateX(-50%);"
                    src="https://static.rhkj.com/renhe_fe/other/398.png"
                    :preview-src-list="['https://static.rhkj.com/renhe_fe/other/398.png']"
                />

                <el-result
                    v-if="uiInfo.successMsg"
                    icon="success"
                    title="麦克风已连接并正常工作"
                    :sub-title="uiInfo.successMsg"
                >
                    <template #extra>
                        <div style="width: 300px;display: flex;align-items: center;color: #222222;">
                            麦克风音量：
                            <el-progress
                                v-if="uiInfo.voicePercent != null"
                                :text-inside="true"
                                :stroke-width="26"
                                :percentage="uiInfo.voicePercent"
                                status="success"
                                style="width: 0;flex-grow: 1;"
                            />
                        </div>

                        <div style="display: flex;align-items: center;margin-top: 30px;color: #222222;">
                            耳机：
                            <div style="display: flex;flex-direction: column;margin-left: 10px;">
                                <audio
                                    src="https://static.rhkj.com/renhe_fe/other/test01.mp3"
                                    controls
                                    style="transform: scale(0.85);position: relative;left: -25px;"
                                />
                                <div style="color: #888888;margin-top: 5px;">请播放音频，测试耳机是否能听到声音，请手动调节音量</div>
                            </div>
                        </div>
                    </template>
                </el-result>
            </div>

            <div class="my-footer">
                <el-button @click="emit('update:visible', false)">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
})

// 检测用变量
let checkInfo = ref({})
const pageLoading = ref(false)
const uiInfo = ref({})

async function onOpen() {
    if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        ElMessageBox.alert("您的浏览器不支持检测，建议更换最新版Google浏览器后再试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
        })
        return
    }
    pageLoading.value = true
    await startCheck() // 开始检测
    pageLoading.value = false
}

async function startCheck() {
    try {
        // 创建音频上下文
        if (!checkInfo.value.audioContext || checkInfo.value.audioContext.state === 'closed') {
            checkInfo.value.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }

        // 获取麦克风流
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: {
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });

        // 获取麦克风设备信息
        const mics = await getMicrophoneList();
        const activeMic = mics.find(mic => mic.deviceId === stream.getAudioTracks()[0].getSettings().deviceId);

        if (activeMic) {
            const resData = activeMic.label || '未命名麦克风';

            // 获取声道数
            const settings = stream.getAudioTracks()[0].getSettings();
            const channel = settings.channelCount || '未知';


            // 设置音量分析器
            checkInfo.value.analyser = checkInfo.value.audioContext.createAnalyser();
            checkInfo.value.analyser.fftSize = 2048;
            const bufferLength = checkInfo.value.analyser.frequencyBinCount;
            checkInfo.value.dataArray = new Uint8Array(bufferLength);

            checkInfo.value.microphone = checkInfo.value.audioContext.createMediaStreamSource(stream);
            checkInfo.value.microphone.connect(checkInfo.value.analyser);

            if (checkInfo.value.intervalId != null) {
                clearInterval(checkInfo.value.intervalId)
                checkInfo.value.intervalId = null;
            }

            checkInfo.value.intervalId = setInterval(() => {
                updateVolume()
            }, 50)
            console.log('识别出麦克风', resData, '设备id：', activeMic.deviceId, '\n输入声道：', channel)
            uiInfo.value.successMsg = `麦克风设备id：${activeMic.deviceId}，声道信息：${channel}`
        } else {
            throw new Error('无法识别活动麦克风');
        }
    } catch (error) {
        console.error('麦克风检测失败:', error);
        if (error.name === 'NotAllowedError') {
            uiInfo.value.errorMsg = '麦克风访问权限被拒绝，请操作浏览器授予权限'
        } else if (error.name === 'NotFoundError') {
            uiInfo.value.errorMsg = '未找到麦克风设备，台式机音频设备需同时连接麦克风与耳机，以启用完整的输入输出功能'
        } else if (error.name === 'NotSupportedError') {
            uiInfo.value.errorMsg = '当前页面不是安全上下文(HTTPS或localhost)'
        } else {
            uiInfo.value.errorMsg = error.message
        }
    }
}

function stopCheck() {
    // 停止更新音量
    if (checkInfo.value.intervalId != null) {
        clearInterval(checkInfo.value.intervalId)
        checkInfo.value.intervalId = null;
    }

    // 关闭麦克风
    if (checkInfo.value.microphone) {
        checkInfo.value.microphone.disconnect();
        checkInfo.value.microphone = null;
    }

    // 如果有活动的音频轨道，停止它们
    if (checkInfo.value.audioContext) {
        const tracks = checkInfo.value.audioContext.activeSourceCount > 0
            ? checkInfo.value.audioContext.getAudioTracks()
            : [];
        tracks.forEach(track => track.stop());
    }
}

// 更新音量显示
function updateVolume() {
    if (!checkInfo.value.analyser) return;

    // 获取音频数据
    checkInfo.value.analyser.getByteFrequencyData(checkInfo.value.dataArray);

    // 计算平均音量
    let sum = 0;
    let count = 0;
    for (let i = 0; i < checkInfo.value.dataArray.length; i++) {
        if (checkInfo.value.dataArray[i] > 0) {
            sum += checkInfo.value.dataArray[i];
            count++;
        }
    }

    // 计算音量 dB (从 0 到 -100)
    const average = count > 0 ? sum / count : 0;
    const db = 20 * Math.log10(average / 255); // 实际上，距离 0 越近，音量越大
    const normalizedDb = parseFloat(Math.max(0, Math.min(100, 100 + db)).toFixed(0));
    console.log('音量', db.toFixed(1), `${normalizedDb}%`)
    uiInfo.value.voicePercent = normalizedDb
}

// 获取麦克风列表
async function getMicrophoneList() {
    try {
        // 首先需要获取一次媒体流以激活权限
        await navigator.mediaDevices.getUserMedia({audio: true});

        const devices = await navigator.mediaDevices.enumerateDevices();
        return devices.filter(device => device.kind === 'audioinput');
    } catch (error) {
        console.error('获取麦克风列表失败:', error);
        throw error;
    }
}

const emit = defineEmits(['update:visible'])

function closedModal() {
    emit('update:visible', false)
    stopCheck()
    uiInfo.value = {}
    checkInfo.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 20px;
}
</style>
